import { useEffect, useMemo, useState } from "react";
import { Col, Row } from "reactstrap";

import AppDrawer from "./AppDrawer";
import { union } from "underscore";
import FieldFormatter from "../Records/Formatters/FieldFormatter";
import useModule from "../../hooks/useModule";
import FieldUtils from "../../utils/FieldUtils";
import { DrawerProps } from "./DrawerTypes";

interface Props extends DrawerProps {
  feedRecord: any;
  userName: string;
}

const FeedItemDrawer = ({ open, onClose, feedRecord, userName }: Props) => {
  const [fromToArray, setFromToArray] = useState<{ From: any; To: any }[]>([]);
  const { module } = useModule(feedRecord?.DataObject?.ModuleAPIName);
  const keys = useMemo(
    () =>
      union(
        Object.keys(feedRecord?.DataObject?.From || {}),
        Object.keys(feedRecord?.DataObject?.To || {})
      ),
    [feedRecord?.DataObject]
  );

  const handleDataObject = async (field: any, prop: string, i: number) => {
    const dataObject = feedRecord?.DataObject;
    let data = dataObject?.[prop]?.[field.APIName];

    // Usings read only Field components
    return (
      <FieldFormatter
        field={field}
        value={data}
        record={null}
        forceReadOnly={true}
      />
    );
  };

  const setUpFromToArray = async () => {
    const arr: { From: any; To: any }[] = [];

    for (let i = 0; i < keys.length; i++) {
      const field = FieldUtils.getFieldFromModule(module, keys[i]);

      let From = await handleDataObject(field, "From", i);
      let To = await handleDataObject(field, "To", i);

      arr.push({ From, To });
    }

    setFromToArray(arr);
  };

  useEffect(() => {
    setUpFromToArray();
  }, [keys]);

  // TODO: Add Revert Button.

  return (
    <AppDrawer
      size={"sm"}
      open={open}
      onClose={onClose}
      headerTitle="Record Activity"
      body={
        <>
          <div className="mb-4 font-weight-600">
            User:
            <span className="font-weight-500 ml-2 text-primary">
              {userName}
            </span>
          </div>
          <Row className="align-items-center">
            <Col xs={4}>
              <h4>Fields Changed</h4>
            </Col>
            <Col xs={4}>
              <h4>Before</h4>
            </Col>
            <Col xs={4}>
              <h4>After</h4>
            </Col>
          </Row>
          <hr className="mt-0 mb-0"></hr>
          {feedRecord?.DataObject?.From &&
            fromToArray !== null &&
            keys?.map((f, i) => {
              const field = FieldUtils.getFieldFromModule(module, f);
              const fromToItem = fromToArray[i];

              return (
                <Row key={i} className="border-bottom py-2 border-superlight">
                  <Col xs={4} className="text-dark font-weight-500 pt-2">
                    {field?.Name}
                  </Col>
                  <Col xs={4}>{fromToItem?.From}</Col>
                  <Col xs={4}>{fromToItem?.To}</Col>
                </Row>
              );
            })}
        </>
      }
    />
  );
};

export default FeedItemDrawer;
